/*
 * Copyright 2024 The Kokabo Authors. All rights reserved.
 * Use of this source code is governed by a BSD-style
 * license that can be found in the LICENSE file.
 */

import {Address, ExclusiveAddress, BroadcastAddress} from "./Address.js";

class Addresses {

    /**
     * @param sender {Address|string}
     * @param receiver {Address|string}
     */
    constructor(sender, receiver) {
        if (typeof sender === 'string') {
            sender = new Address(sender);
        }
        if (typeof receiver === 'string') {
            receiver = new Address(receiver);
        }
        this.sender = sender;
        this.receiver = receiver;
    }

    inverse(){
        return new Addresses( this.receiver.inverse(), this.sender.inverse())
    }

    toString(){
        return `${this.sender}::${this.receiver}`;
    }
}


const DefaultAddresses = new Addresses(ExclusiveAddress, BroadcastAddress);

export {Addresses, DefaultAddresses};